import { DateTime } from 'luxon';

export class DateFormatter {
  static formatDate(date?: Date): string {
    if (!date) return '';
    return DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_SHORT);
  }
}
